import React, { useState,useEffect } from 'react';
import { trackEvent } from "../../services/analytics";
import { useTranslation } from 'react-i18next';

const Section = props => {
    const { t, i18n } = useTranslation();
    const onClickSignUp = (name) => {
        trackEvent('Click',{
            action: "track",
            category: "Buttons",
            label: name,
            event: "Click"
        })
    };

    const onClickSales = (name) => {
        trackEvent('Contact Sales',{
            action: "track",
            category: "Buttons",
            label: name,
            event: "Click"
        })
    }

    return (
        <section className="slice-video d-flex align-items-center bg-skew bg-transparent">
            <div className="container">
                <div className="row align-items-center">

                    <div className="col-lg-8">
                        <div className="">
                            <h2 className="text-swift-pink">
                                <strong>{t('footer.easyYourShipment')}</strong>
                            </h2>
                            <p className="lead lh-180 mt-3 text-black" style={{color:'black'}}>{t('footer.startNow')}</p>
                        </div>
                    </div>

                    <div className="col-lg-4 row">
                        <div className="col-6">
                            <a href="https://s.id/biteship-web-home-sales-section"  onClick={() => onClickSales('Contact Sales Bottom Section')}>
                                <button className="btn btn-primary btn-block">{t('footer.contact')}</button>
                            </a>
                        </div>
                        <div className="col-6">
                            <a href="https://dashboard.biteship.com/signup" onClick={() => onClickSignUp('Sign Up Bottom Section')}>
                                <button className="btn btn-outline-primary btn-block ">{t('footer.signUp')}</button>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
};

export default Section;
